import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appPositiveOrZero',
  standalone: true,
})
export class PositiveOrZeroPipe implements PipeTransform {
  transform(value: number): number {
    return value >= 0 ? value : 0;
  }
}
